import { Box, CssBaseline, CssVarsProvider } from '@mui/joy'
import React, { useState } from 'react'
import EmployeeSidebar from '../../EmployeeSidebar'
import { SelectInput } from '../../../utils/input'

export default function UserMaintenance() {
  const [allow, setAllow] = useState("");
  const option: any = [{ value: "Option1", label: "Option1" }, { value: "Option2", label: "Option2" }, { value: "Option3", label: "Option3" }];

  const handleSelectChange = (name: string, value: string) => {
    setAllow(value)
  }
  return (
    <CssVarsProvider disableTransitionOnChange>
      <CssBaseline />
      <Box sx={{ display: "flex", minHeight: "92dvh", background: 'white' }}>
        <EmployeeSidebar />
        {/* <div className="add-entry-outer register-box">
               <Box sx={{p: { xs: 1.5, md: 2.5 },display: "flex",flexDirection: "column",gap: 2.5,pb: "130px"}}>
                 <SelectInput
                    name="assignedTo"
                    label="Assign To"
                    value={allow}
                    onChange={handleSelectChange}
                    options={option}
                    />
                                 
                </Box>
           </div> */}
      </Box>
    </CssVarsProvider>
  )
}
